// import React, { useState, useContext } from "react";
// import { Slider, Rail, Handles, Tracks } from "react-compound-slider";
// import axios from "axios";
// import { GlobalState } from "../../GlobalState";
// import Handle from "./Handle";
// import Track from "./Track";
// import styled from "styled-components";

// const Container = styled.div`
//   background: #fff;
//   border-radius: 20px;
//   margin: 1rem auto;
//   padding: 2rem;
//   box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   @media (min-width: 61.313em) {
//     flex-direction: row;
//     justify-content: space-between;
//   }
// `;
// const sliderStyle = {
//   position: "relative",
//   width: "100%",
// };
// const UpdateBtn = styled.button`
//   margin-top: 5rem;
//   cursor: pointer;
//   color: var(--background);
//   background-color: var(--primary);
//   border: none;
//   outline: none;
//   font-size: 1rem;
//   padding: 0.3rem 1rem;
//   border-radius: 20px;
//   @media (min-width: 61.313em) {
//     margin-top: 1rem;
//     margin-left: 0.5rem;
//   }

//   &:disabled {
//     background-color: #c4c4c4;
//     cursor: not-allowed;
//   }
// `;
// const SliderWrapper = styled.div`
//   width: 100%;

//   margin-top: -1.5rem;
//   @media (min-width: 61.313em) {
//     width: 80%;
//   }
// `;
// const railStyle = {
//   position: "absolute",
//   width: "100%",
//   height: 7.5,
//   marginTop: 35,
//   borderRadius: 5,
//   backgroundColor: "#C4C4C4",
// };

// export default function DoubleRangeSlider({
//   defautvalues,
//   sensor_id,
//   ...props
// }) {

//   const onChange = (values) => {
//     setvalues({ values });
//   };
//   const state = useContext(GlobalState);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     seterr("updating....")

//     const updates = props.type ? props.type.toLowerCase().includes('temperature')
//       ? { lower_limit_1: values.values[0], upper_limit_1: values.values[1] }
//       : props.type.toLowerCase().includes('humidity')
//         ? { lower_limit_2: values.values[0], upper_limit_2: values.values[1] }
//         : { lower_limit: values.values[0], upper_limit: values.values[1] }
//       : { lower_limit: values.values[0], upper_limit: values.values[1] };

//     const res = await axios.put(
//       `${process.env.REACT_APP_API}/sensor/update_limit?sensor_id=${sensor_id}`,
//       updates,
//       {
//         headers: { Authorization: state.token[0] },
//       }
//     );
//     if (res.status === 200) {
//       seterr(res.data.message)
//     }

//     setTimeout(() => {
//       seterr("")
//     }, 3000);
//   };
//   const [values, setvalues] = useState(defautvalues);
//   const [err, seterr] = useState(null)
//   return (
//     <>
//       <Container>
//         <SliderWrapper>
//           {props.name}
//           <Slider
//             disabled={props.disabled}
//             rootStyle={sliderStyle}
//             domain={[0, 100]}
//             step={1}
//             mode={2}
//             onChange={onChange}
//             values={defautvalues}
//           >
//             <Rail>
//               {({ getRailProps }) => (
//                 <div style={railStyle} {...getRailProps()} />
//               )}
//             </Rail>
//             <Handles>
//               {({ handles, getHandleProps }) => (
//                 <div className="slider-handles">
//                   {handles.map((handle) => (
//                     <Handle
//                       key={handle.id}
//                       handle={handle}
//                       getHandleProps={getHandleProps}
//                     />
//                   ))}
//                 </div>
//               )}
//             </Handles>
//             <Tracks left={false} right={false}>
//               {({ tracks, getTrackProps }) => (
//                 <div className="slider-tracks">
//                   {tracks.map(({ id, source, target }) => (
//                     <Track
//                       key={id}
//                       source={source}
//                       target={target}
//                       getTrackProps={getTrackProps}
//                     />
//                   ))}
//                 </div>
//               )}
//             </Tracks>
//           </Slider>
//         </SliderWrapper>
//         <UpdateBtn
//           disabled={props.disabled}
//           onClick={handleSubmit}>{err ? err : "Update"}</UpdateBtn>

//       </Container>
//     </>
//   );
// }



// import React, { useState, useContext } from "react";
// import { Slider, Rail, Handles, Tracks } from "react-compound-slider";
// import axios from "axios";
// import { GlobalState } from "../../GlobalState";
// import Handle from "./Handle";
// import Track from "./Track";
// import styled from "styled-components";
// import { CiSettings } from "react-icons/ci";
// import { FaBlackTie, FaYelp } from "react-icons/fa";
// import { NavLink } from "react-router-dom/cjs/react-router-dom";
// import { generatePath } from "react-router-dom/cjs/react-router-dom.min";

// const Container = styled.div`
//   border-radius: 14px;
//   padding: 0.2rem 0.9rem;
//   max-width: 230px; /* ✅ same as SensorWrapper */
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 0.6rem;
// `;

// const UpdateBtn = styled.button`
//   cursor: pointer;
//   color: #fff;
//   background-color: #5a82ff;
//   border: none;
//   outline: none;
//   font-size: 0.9rem;
//   padding: 0.35rem 1rem;
//   border-radius: 14px;
//   transition: background-color 0.3s ease;
//   width: 80%;
//   text-align: center;

//   &:hover:not(:disabled) {
//     background-color: rgb(31, 84, 244);
//   }

//   &:disabled {
//     background-color: #c4c4c4;
//     cursor: not-allowed;
//   }
// `;

// const SliderWrapper = styled.div`
//   width: 100%;
//   height: 40px;          /* fixed height for proper alignment */
//   position: relative;
//   display: flex;
//   align-items: center;   /* center rail & handles vertically */
//   margin: 0.3rem 0;
// `;

// const HeaderWrapper = styled.div`
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   gap: 0.5rem;
//   text-align: center;
//   margin: 0.5rem 0;

  
//   svg {
//     color: #004080;
//   }
  
//   span {
//     font-size: 0.9rem;
//     font-weight: 600;
//     color: #333;
//   }
// `;

// const railStyle = {
//   position: "absolute",
//   width: "100%",
//   height: 6,            
//   borderRadius: 3,
//   backgroundColor: "#cad9ef",
//   top: "50%",            
//   transform: "translateY(-50%)",
// };

// const trackStyle = (source, target) => ({
//   position: "absolute",
//   height: 6,
//   borderRadius: 3,
//   backgroundColor: "#5a82ff",
//   top: "50%",
//   transform: "translateY(-50%)",
// });


// export default function DoubleRangeSlider({ defautvalues, sensor_id, ...props }) {
//   const state = useContext(GlobalState);
//   const [values, setvalues] = useState(defautvalues);
//   const [err, seterr] = useState(null);

//   const onChange = (values) => setvalues({ values });

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     seterr("Updating...");

//     const updates = props.type
//       ? props.type.toLowerCase().includes("temperature")
//         ? { lower_limit_1: values.values[0], upper_limit_1: values.values[1] }
//         : props.type.toLowerCase().includes("humidity")
//         ? { lower_limit_2: values.values[0], upper_limit_2: values.values[1] }
//         : { lower_limit: values.values[0], upper_limit: values.values[1] }
//       : { lower_limit: values.values[0], upper_limit: values.values[1] };

//     const res = await axios.put(
//       `${process.env.REACT_APP_API}/sensor/update_limit?sensor_id=${sensor_id}`,
//       updates,
//       { headers: { Authorization: state.token[0] } }
//     );

//     if (res.status === 200) seterr(res.data.message);
//     setTimeout(() => seterr(""), 3000);
//   };

//   return (
//     <Container>
//       <HeaderWrapper>
//          <CiSettings size={26} />
//         <span>{props.name}</span>
//       </HeaderWrapper>
//       <SliderWrapper>
//         <Slider
//           disabled={props.disabled}
//           rootStyle={{ position: "relative", width: "100%" }}
//           domain={[0, 100]}
//           step={1}
//           mode={2}
//           onChange={onChange}
//           values={defautvalues}
//         >
//           <Rail>
//             {({ getRailProps }) => <div style={railStyle} {...getRailProps()} />}
//           </Rail>
//           <Handles>
//             {({ handles, getHandleProps }) => (
//               <div className="slider-handles">
//                 {handles.map((handle) => (
//                   <Handle key={handle.id} handle={handle} getHandleProps={getHandleProps} />
//                 ))}
//               </div>
//             )}
//           </Handles>
//           {/* <Tracks left={false} right={false}>
//             {({ tracks, getTrackProps }) => (
//               <div className="slider-tracks">
//                 {tracks.map(({ id, source, target }) => (
//                   <Track key={id} source={source} target={target} getTrackProps={getTrackProps} />
//                 ))}
//               </div>
//             )}
//           </Tracks> */}

//           <Tracks left={false} right={false}>
//           {({ tracks, getTrackProps }) => (
//             <div className="slider-tracks">
//               {tracks.map(({ id, source, target }) => (
//                 <div
//                   key={id}
//                   style={{
//                     ...trackStyle(source, target),
//                     left: `${source.percent}%`,
//                     width: `${target.percent - source.percent}%`,
//                   }}
//                   {...getTrackProps()}
//                 />
//               ))}
//             </div>
//           )}
//           </Tracks>
//         </Slider>
//       </SliderWrapper>
//       <UpdateBtn disabled={props.disabled} onClick={handleSubmit}>
//         {err ? err : "Update"}
//       </UpdateBtn>
//     </Container>
//   );
// }


// import React, { useState, useContext } from "react";
// import axios from "axios";
// import { GlobalState } from "../../GlobalState";
// import styled from "styled-components";
// import { CiSettings } from "react-icons/ci";

// const Container = styled.div`
//   border-radius: 14px;
//   padding: 0.2rem 0.9rem;
//   max-width: 230px;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 0.6rem;
// `;

// const HeaderWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
//   margin: 0.5rem 0;
  
//   svg {
//     color: #004080;
//   }
//   span {
//     font-size: 0.8rem;
//     font-weight: 600;
//     color: #333;
//   }
// `;

// const InputContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.8rem;
//   width: 100%;
// `;

// const InputBox = styled.div`
//   // background: #f8faff;
//   border: 1px solid #cad9ef;
//   border-radius: 12px;
//   padding: 0.4rem 0.2rem;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

//   label {
//     font-size: 0.9rem;
//     font-weight: 600;
//     color: #004080;
//     flex: 1;
//     text-align: left;
//   }

//   input {
//     width: 30%;
//     padding: 0.2rem;
//     border-radius: 10px;
//     border: 1px solid #ccc;
//     text-align: center;
//     font-size: 0.9rem;
//     transition: all 0.2s ease;

//     &:focus {
//       border-color: #5a82ff;
//       outline: none;
//       box-shadow: 0 0 4px rgba(90, 130, 255, 0.4);
//     }

//     &:disabled {
//       background: #f4f4f4;
//       cursor: not-allowed;
//     }
//   }

//   &:hover {
//     box-shadow: 0 0 6px rgba(90, 130, 255, 0.15);
//   }
// `;

// const UpdateBtn = styled.button`
//   cursor: pointer;
//   color: #fff;
//   background-color: #5a82ff;
//   border: none;
//   font-size: 0.9rem;
//   padding: 0.35rem 1rem;
//   border-radius: 14px;
//   transition: background-color 0.3s ease;
//   width: 80%;

//   &:hover:not(:disabled) {
//     background-color: rgb(31, 84, 244);
//   }

//   &:disabled {
//     background-color: #c4c4c4;
//     cursor: not-allowed;
//   }
// `;

// export default function DoubleRangeSlider({ defautvalues, sensor_id, ...props }) {
//   const state = useContext(GlobalState);
//   const [values, setValues] = useState({
//     lower: defautvalues[0],
//     upper: defautvalues[1],
//   });
//   const [err, setErr] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setErr("Updating...");

//     const updates = props.type
//       ? props.type.toLowerCase().includes("temperature")
//         ? { lower_limit_1: values.lower, upper_limit_1: values.upper }
//         : props.type.toLowerCase().includes("humidity")
//         ? { lower_limit_2: values.lower, upper_limit_2: values.upper }
//         : { lower_limit: values.lower, upper_limit: values.upper }
//       : { lower_limit: values.lower, upper_limit: values.upper };

//     try {
//       const res = await axios.put(
//         `${process.env.REACT_APP_API}/sensor/update_limit?sensor_id=${sensor_id}`,
//         updates,
//         { headers: { Authorization: state.token[0] } }
//       );

//       if (res.status === 200) setErr(res.data.message);
//     } catch (error) {
//       setErr("Error updating");
//     }

//     setTimeout(() => setErr(""), 3000);
//   };

//   return (
//     <Container>
//       <HeaderWrapper>
//         <CiSettings size={26} />
//         <span>{props.name}</span>
//       </HeaderWrapper>

// <InputContainer>
//   <InputBox>
//     <h5>Min % Value</h5>
//     <input
//       type="number"
//       value={values.lower}
//       onChange={(e) => setValues({ ...values, lower: e.target.value })}
//       disabled={props.disabled}
//       placeholder="Lower limit"
//     />
//   </InputBox>

//   <InputBox>
//     <h5>Max % Value</h5>
//     <input
//       type="number"
//       value={values.upper}
//       onChange={(e) => setValues({ ...values, upper: e.target.value })}
//       disabled={props.disabled}
//       placeholder="Upper limit"
//     />
//   </InputBox>
// </InputContainer>



//       <UpdateBtn disabled={props.disabled} onClick={handleSubmit}>
//         {err ? err : "Update"}
//       </UpdateBtn>
//     </Container>
//   );
// }



// import React, { useState, useContext } from "react";
// import axios from "axios";
// import { GlobalState } from "../../GlobalState";
// import styled from "styled-components";
// import { CiSettings } from "react-icons/ci";
// import { FiEdit2 } from "react-icons/fi";
// import { MdClose } from "react-icons/md";

// const Container = styled.div`
//   border-radius: 14px;
//   padding: 0.2rem 0.9rem;
//   max-width: 230px;
//   width: 100%;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 0.6rem;
// `;

// const HeaderWrapper = styled.div`
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   width: 100%;
//   margin: 0.5rem 0;
// `;

// const TitleSection = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 0.5rem;
  
//   svg {
//     color: #004080;
//   }
//   span {
//     font-size: 0.8rem;
//     font-weight: 600;
//     color: #333;
//   }
// `;

// const EditButton = styled.button`
//   background: ${props => props.isEditing ? '#ff4444' : '#5a82ff'};
//   border: none;
//   border-radius: 8px;
//   padding: 0.4rem;
//   display: flex;
//   align-items: center;
//   justify-content: center;
//   cursor: pointer;
//   transition: all 0.3s ease;
  
//   svg {
//     color: white;
//     font-size: 1rem;
//   }
  
//   &:hover {
//     background: ${props => props.isEditing ? '#cc0000' : '#4066cc'};
//     transform: scale(1.05);
//   }
  
//   &:disabled {
//     background: #c4c4c4;
//     cursor: not-allowed;
//     transform: none;
//   }
// `;

// const InputContainer = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.8rem;
//   width: 100%;
// `;

// const InputBox = styled.div`
//   border: 1px solid #cad9ef;
//   border-radius: 12px;
//   padding: 0.4rem 0.2rem;
//   display: flex;
//   align-items: center;
//   justify-content: space-between;
//   box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

//   h5 {
//     font-size: 0.9rem;
//     font-weight: 600;
//     color: #004080;
//     flex: 1;
//     text-align: right;
//     margin: 0;
//   }

//   input {
//     width: 30%;
//     padding: 0.2rem;
//     border-radius: 10px;
//     border: 1px solid #ccc;
//     text-align: center;
//     font-size: 0.9rem;
//     transition: all 0.2s ease;
//     display: "flex",
//     flexDirection: "column",
//     color: "#1e40af",
//     fontWeight: "600",
//     fontSize: "0.75rem",
//     lineHeight: "1.2",
//     minWidth: "80px",

//     &:focus {
//       border-color: #5a82ff;
//       outline: none;
//       box-shadow: 0 0 4px rgba(90, 130, 255, 0.4);
//     }

//     &:disabled {
//       background: #f4f4f4;
//       cursor: not-allowed;
//       color: #666;
//     }
//   }

//   &:hover {
//     box-shadow: 0 0 6px rgba(90, 130, 255, 0.15);
//   }
// `;

// const UpdateBtn = styled.button`
//   cursor: pointer;
//   color: #fff;
//   background-color: #5a82ff;
//   border: none;
//   font-size: 0.9rem;
//   padding: 0.35rem 1rem;
//   border-radius: 14px;
//   transition: background-color 0.3s ease;
//   width: 80%;

//   &:hover:not(:disabled) {
//     background-color: rgb(31, 84, 244);
//   }

//   &:disabled {
//     background-color: #c4c4c4;
//     cursor: not-allowed;
//   }
// `;

// export default function DoubleRangeSlider({ defautvalues, sensor_id, ...props }) {
//   const state = useContext(GlobalState);
//   const [isEditing, setIsEditing] = useState(false);
//   const [values, setValues] = useState({
//     lower: defautvalues[0],
//     upper: defautvalues[1],
//   });
//   const [err, setErr] = useState("");

//   const handleEditToggle = () => {
//     if (isEditing) {
//       // Cancel editing - reset to default values
//       setValues({
//         lower: defautvalues[0],
//         upper: defautvalues[1],
//       });
//     }
//     setIsEditing(!isEditing);
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();
//   //   setErr("Updating...");

//   //   const updates = props.type
//   //     ? props.type.toLowerCase().includes("temperature")
//   //       ? { lower_limit_1: values.lower, upper_limit_1: values.upper }
//   //       : props.type.toLowerCase().includes("humidity")
//   //       ? { lower_limit_2: values.lower, upper_limit_2: values.upper }
//   //       : { lower_limit: values.lower, upper_limit: values.upper }
//   //     : { lower_limit: values.lower, upper_limit: values.upper };

//   //   try {
//   //     const res = await axios.put(
//   //       `${process.env.REACT_APP_API}/sensor/update_limit?sensor_id=${sensor_id}`,
//   //       updates,
//   //       { headers: { Authorization: state.token[0] } }
//   //     );

//   //     if (res.status === 200) {
//   //       setErr(res.data.message);
//   //       setIsEditing(false);
//   //     }
//   //   } catch (error) {
//   //     setErr("Error updating");
//   //   }

//   //   setTimeout(() => setErr(""), 3000);
//   // };


//   const handleSubmit = async (e) => {
//   e.preventDefault();

//   // Validation: max must be greater than min
//   if (values.upper <= values.lower) {
//     setErr("Max value must be greater than Min value");
//     setTimeout(() => setErr(""), 3000);
//     return; // stop submission
//   }

//   setErr("Updating...");

//   const updates = props.type
//     ? props.type.toLowerCase().includes("temperature")
//       ? { lower_limit_1: values.lower, upper_limit_1: values.upper }
//       : props.type.toLowerCase().includes("humidity")
//       ? { lower_limit_2: values.lower, upper_limit_2: values.upper }
//       : { lower_limit: values.lower, upper_limit: values.upper }
//     : { lower_limit: values.lower, upper_limit: values.upper };

//   try {
//     const res = await axios.put(
//       `${process.env.REACT_APP_API}/sensor/update_limit?sensor_id=${sensor_id}`,
//       updates,
//       { headers: { Authorization: state.token[0] } }
//     );

//     if (res.status === 200) {
//       setErr(res.data.message);
//       setIsEditing(false); // Exit edit mode after successful update
//     }
//   } catch (error) {
//     setErr("Error updating");
//   }

//   setTimeout(() => setErr(""), 3000);
// };

//   return (
//     <Container>
//       <HeaderWrapper>
//         <TitleSection>
//           <CiSettings size={28} />
//           <span>{props.name}</span>
//         </TitleSection>
        
//         <EditButton 
//           onClick={handleEditToggle}
//           disabled={props.disabled}
//           isEditing={isEditing}
//           title={isEditing ? "Cancel" : "Edit"}
//         >
//           {isEditing ? <MdClose /> : <FiEdit2 />}
//         </EditButton>
//       </HeaderWrapper>

//       <InputContainer>
//         <InputBox>

//           <input
//     type="number"
//     value={values.lower}
//     onChange={(e) => {
//       const val = Number(e.target.value);
//       if (val >= 0 && val <= 100) {
//         setValues({ ...values, lower: val });
//       }
//     }}
//     disabled={!isEditing || props.disabled}
//     placeholder="Lower limit"
//     min="0"
//     max="1
//     00"
//   />
//             <h5>Min % Value</h5>
//         </InputBox>

//         <InputBox>

//     <input
//     type="number"
//     value={values.upper}
//     onChange={(e) => {
//       const val = Number(e.target.value);
//       if (val >= 0 && val <= 100) 
//         {
//         setValues({ ...values, upper: val });
//       }
//     }}    
//     disabled={!isEditing || props.disabled}
//     placeholder="Upper limit"
//     min="0"
//     max="100"
//   />
//             <h5>Max % Value</h5>
//         </InputBox>
//       </InputContainer>

//       <UpdateBtn 
//         disabled={!isEditing || props.disabled} 
//         onClick={handleSubmit}
//       >
//         {err ? err : "Update"}
//       </UpdateBtn>
//     </Container>
//   );
// }



import React, { useState, useContext } from "react";
import axios from "axios";
import { GlobalState } from "../../GlobalState";
import styled from "styled-components";
import { CiSettings } from "react-icons/ci";
import { FiEdit2 } from "react-icons/fi";
import { MdClose } from "react-icons/md";

const Container = styled.div`
  border-radius: 14px;
  padding: 0.4rem 0.9rem;
  width: 100%;
  min-width: 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0.3rem 0;
  gap: 0.3rem;
`;

const TitleSection = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  min-width: 0;

  svg {
    color: #004080;
    flex-shrink: 0;
  }

  span {
    font-size: 0.78rem;
    font-weight: 600;
    color: #333;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const EditButton = styled.button`
  background: ${(props) => (props.isEditing ? "#ff4444" : "#5a82ff")};
  border: none;
  border-radius: 8px;
  padding: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;

  svg {
    color: white;
    font-size: 1rem;
  }

  &:hover {
    background: ${(props) => (props.isEditing ? "#cc0000" : "#4066cc")};
    transform: scale(1.05);
  }

  &:disabled {
    background: #c4c4c4;
    cursor: not-allowed;
    transform: none;
  }
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  width: 100%;
`;

const InputBox = styled.div`
  border: 1px solid #cad9ef;
  border-radius: 12px;
  padding: 0.4rem 0.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  min-width: 0;

  h5 {
    font-size: 0.78rem;
    font-weight: 600;
    color: #004080;
    margin: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 1;
  }

  input {
    width: 55px;
    min-width: 0;
    padding: 0.25rem 0.3rem;
    border-radius: 10px;
    border: 1px solid #ccc;
    text-align: center;
    font-size: 0.85rem;
    font-weight: 600;
    color: #1e40af;
    background: #fff;
    transition: all 0.2s ease;
    flex-shrink: 0;

    &:focus {
      border-color: #5a82ff;
      outline: none;
      box-shadow: 0 0 4px rgba(90, 130, 255, 0.4);
    }

    &:disabled {
      background: #f4f4f4;
      cursor: not-allowed;
      color: #666;
    }
  }

  &:hover {
    box-shadow: 0 0 6px rgba(90, 130, 255, 0.15);
  }
`;

const UpdateBtn = styled.button`
  cursor: pointer;
  color: #fff;
  background-color: #5a82ff;
  border: none;
  font-size: 0.85rem;
  padding: 0.4rem 1rem;
  border-radius: 14px;
  transition: background-color 0.3s ease;
  width: 80%;
  margin-top: 0.2rem;

  &:hover:not(:disabled) {
    background-color: rgb(31, 84, 244);
  }

  &:disabled {
    background-color: #c4c4c4;
    cursor: not-allowed;
  }
`;

export default function DoubleRangeSlider({ defautvalues, sensor_id, ...props }) {
  const state = useContext(GlobalState);
  const [isEditing, setIsEditing] = useState(false);
  const [values, setValues] = useState({
    lower: defautvalues[0],
    upper: defautvalues[1],
  });
  const [err, setErr] = useState("");

  const handleEditToggle = () => {
    if (isEditing) {
      setValues({
        lower: defautvalues[0],
        upper: defautvalues[1],
      });
    }
    setIsEditing(!isEditing);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (values.upper <= values.lower) {
      setErr("Max must be greater than Min");
      setTimeout(() => setErr(""), 3000);
      return;
    }

    setErr("Updating...");

    const updates = props.type
      ? props.type.toLowerCase().includes("temperature")
        ? { lower_limit_1: values.lower, upper_limit_1: values.upper }
        : props.type.toLowerCase().includes("humidity")
        ? { lower_limit_2: values.lower, upper_limit_2: values.upper }
        : { lower_limit: values.lower, upper_limit: values.upper }
      : { lower_limit: values.lower, upper_limit: values.upper };

    try {
      const res = await axios.put(
        `${process.env.REACT_APP_API}/sensor/update_limit?sensor_id=${sensor_id}`,
        updates,
        { headers: { Authorization: state.token[0] } }
      );

      if (res.status === 200) {
        setErr(res.data.message);
        setIsEditing(false);
      }
    } catch (error) {
      setErr("Error updating");
    }

    setTimeout(() => setErr(""), 3000);
  };

  return (
    <Container>
      <HeaderWrapper>
        <TitleSection>
          <CiSettings size={22} />
          <span>{props.name}</span>
        </TitleSection>

        <EditButton
          onClick={handleEditToggle}
          disabled={props.disabled}
          isEditing={isEditing}
          title={isEditing ? "Cancel" : "Edit"}
        >
          {isEditing ? <MdClose /> : <FiEdit2 />}
        </EditButton>
      </HeaderWrapper>

      <InputContainer>
        <InputBox>
          <input
            type="number"
            value={values.lower}
            onChange={(e) => {
              const val = Number(e.target.value);
              if (val >= 0 && val <= 100) {
                setValues({ ...values, lower: val });
              }
            }}
            disabled={!isEditing || props.disabled}
            placeholder="Min"
            min="0"
            max="100"
          />
          <h5>Min % Value</h5>
        </InputBox>

        <InputBox>
          <input
            type="number"
            value={values.upper}
            onChange={(e) => {
              const val = Number(e.target.value);
              if (val >= 0 && val <= 100) {
                setValues({ ...values, upper: val });
              }
            }}
            disabled={!isEditing || props.disabled}
            placeholder="Max"
            min="0"
            max="100"
          />
          <h5>Max % Value</h5>
        </InputBox>
      </InputContainer>

      <UpdateBtn disabled={!isEditing || props.disabled} onClick={handleSubmit}>
        {err ? err : "Update"}
      </UpdateBtn>
    </Container>
  );
}